import { memo } from 'react';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const Index = (props) => {
  const { paginationInfo } = props;
  const { currentPage, paginationPages, countPage } = paginationInfo;
  const changePage = (page) => {
    if (currentPage === page || page === '...') {
      return false;
    }
    props?.changePagination(page);
  };
  return (
    <div className={'flex'}>
      <ul className={'flex flex-1 items-center justify-center'}>
        {currentPage > 1 && (
          <li
            onClick={() => changePage(currentPage - 1)}
            className={'mr-[8px] flex size-[32px] cursor-pointer items-center justify-center hover:text-[#1677FF]'}
          >
            <LeftOutlined />
          </li>
        )}
        {(paginationPages || []).map((item, index) => {
          return (
            <li
              key={index}
              onClick={() => changePage(item.page)}
              className={'mr-[8px] flex size-[32px] items-center justify-center text-[#000000]'}
            >
              {item.page === '...' ? (
                <>...</>
              ) : (
                <span
                  className={`flex size-[32px] text-[14px] ${currentPage === item.page ? 'bg-white' : ''} cursor-pointer items-center justify-center text-[#000000] hover:rounded-[6px] hover:border  hover:border-solid  hover:border-[#1677FF]  hover:bg-white  hover:text-[#0093E6] ${currentPage === item.page ? 'rounded-[6px] border border-solid border-[#1677FF] text-[#0093E6]' : ''}`}
                >
                  {item.page}
                </span>
              )}
            </li>
          );
        })}
        {countPage > currentPage && (
          <li
            className={'flex size-[32px] cursor-pointer items-center  justify-center hover:text-[#1677FF]'}
            onClick={() => changePage(currentPage + 1)}
          >
            <RightOutlined />
          </li>
        )}
      </ul>
    </div>
  );
};

export default memo(Index);
